/**
 * @module utils
 * @private
 */
import { emit } from "../web/manager/player/listeners";
import errors from "../web/errors";

const MILLISECONDS = 1000;
const MINUTES_IN_MILLISECONDS = 60 * MILLISECONDS;
const HOURS_IN_MILLISECONDS = 60 * MINUTES_IN_MILLISECONDS;

let subtitlesList = null;
let position = 0;
let lastPosition = 0;
let currentText = "";
let querySelectors = null;

/**
 * Returns a XML document parsed as Object
 * @param {xmlDocument} xml Xml document
 */
function parseXml(xml) {
  const parser = new window.DOMParser();
  const xmlDocument = parser.parseFromString(xml, "text/xml");
  (querySelectors === null || querySelectors.length === 0) &&
    (querySelectors = xmlDocument.querySelectorAll("body p[begin][end]"));
  if (
    querySelectors.length &&
    (this.typeOf(xmlDocument) === "document" || this.typeOf(xmlDocument) === "xmldocument")
  ) {
    querySelectors = xmlDocument.querySelectorAll("body p[begin][end]");
  }
  return querySelectors;
}

/**
 * Returns the subtitle time formatted
 * @param {Array} arrayDate
 */
function getTime(arrayDate) {
  let ms = arrayDate[2] * MILLISECONDS;
  ms += arrayDate[1] * MINUTES_IN_MILLISECONDS; // minutes
  ms += arrayDate[0] * HOURS_IN_MILLISECONDS; // hours
  return ms;
}

function removeSpans(node) {
  return node.nodeName === "span" ? node.innerHTML : node;
}

/**
 * Returns the content of the node
 * @param {Object} node
 */
function getNodeContent(node) {
  const brs = ["br", "<br>", "<br/>", "<br />", "</br>"];
  let content = "";
  if (brs.indexOf(node.nodeName) > -1 || brs.indexOf(node.data) > -1) {
    content = "<br>";
  } else if (node.data) {
    content = node.data;
  } else if (node) {
    content = node;
  }
  return content;
}

/**
 * Returns the subtitle text formatted
 * @param {htmlList} textList List of html nodes
 */
function formatText(textList) {
  let text = "";
  for (let i = 0, len = textList.length; i < len; i++) {
    const node = removeSpans(textList[i]);
    text += getNodeContent(node);
  }
  return text;
}

/**
 * Sends subtitle text and duration to app which is listening for event "subtitleChange"
 * @param {Number} duration Subtitle duration
 * @param {String} text Subtitle text
 */
function setSubtitleText(duration, text) {
  if (currentText !== text) {
    currentText = text;
    emit("subtitleChange", { duration, text });
  }
}

export function resetSubtitlesList() {
  subtitlesList = null;
  querySelectors = null;
  position = 0;
}

/**
 * Updates subtitles
 * @param {Array} subtitles Array of elements with subtitle information (begin, end, text)
 * @param {*} time The current time of the playback
 */
export function update(subtitles, time) {
  try {
    const currentTime = time || this.playerManager.getCurrentTime();
    subtitlesList = subtitlesList || parseXml.call(this, subtitles);

    if (subtitlesList) {
      let textInserted = false;
      let duration = 0;
      for (let i = 0, len = subtitlesList.length; i < len; i++) {
        const p = subtitlesList[i];
        if (i >= position) {
          const begin = getTime(p.getAttribute("begin").split(":"));
          const end = getTime(p.getAttribute("end").split(":"));
          duration = end - begin;
          if (begin <= currentTime && end >= currentTime) {
            setSubtitleText(duration, formatText(p.childNodes));
            textInserted = true;
            position = i;
            if (position !== lastPosition) {
              lastPosition = position;
            }
            break;
          } else if (begin > currentTime) {
            position = i;
            break;
          }
        }
        if (!textInserted) {
          setSubtitleText(duration, "");
        }
      }
    }
  } catch (e) {
    throw new Error(errors.player.NOT_READ_EXTERNAL_SUBTITLES);
  }
}
